<template>
	<div
		class="property-form"
		:class="{ 'shrink': !isVisible }">
		<div class="d-flex align-items-start justify-content-between">
			<div class="property-title ">
				<div class="row">
					<div class="col-md-12">
						<span>{{ $t('Asset Properties') }}</span>
					</div>
					<div class="col-md-12">
						<span class="text-grey small">{{ $t('No Active Selected Asset') }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>


export default {
	name: 'BlankProperty',
	props: {
		data: {
			type: Boolean,
		},
	},
	components: {
	},
	data() {
		return {
			isVisible: true,
		};
	},
	methods: {
		initData() {
			this.isVisible = true;
		},
	},
	watch: {
		data(value) {
			if (value) {
				this.initData();
			}
		},
	},
	created() {
		this.initData();
	},
};
</script>
